var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#1D1D1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5939 14.4065C16.0137 13.8265 15.2269 13.5007 14.4065 13.5007C13.5862 13.5007 12.7994 13.8265 12.2192 14.4065L10.0312 16.5938C9.45096 17.174 9.125 17.961 9.125 18.7815C9.125 19.6021 9.45096 20.389 10.0312 20.9692C10.6114 21.5494 11.3983 21.8754 12.2189 21.8754C13.0394 21.8754 13.8263 21.5494 14.4065 20.9692L15.5002 19.8755",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4062 16.5939C14.9865 17.1738 15.7732 17.4996 16.5936 17.4996C17.4139 17.4996 18.2007 17.1738 18.7809 16.5939L20.969 14.4065C21.5492 13.8263 21.8751 13.0394 21.8751 12.2189C21.8751 11.3983 21.5492 10.6114 20.969 10.0312C20.3887 9.45096 19.6018 9.125 18.7813 9.125C17.9607 9.125 17.1738 9.45096 16.5936 10.0312L15.4999 11.1248",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.8e9bad79b74fb7c452926284dd223d3f.svg";
export { ForwardRef as ReactComponent };